module.exports = __webpack_public_path__ + "img/img0.43672606.jpg";